import { NgModule } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharedModule } from '../shared/shared.module';
import { ContentPreviewComponent } from './content-preview/content-preview.component';
import { ContentAccessComponent } from './content-access/content-access.component';
import { MenuModule } from '../menu/menu.module';
import { ButtonsModule } from '../buttons/buttons.module';



@NgModule({
    declarations: [ContentPreviewComponent, ContentAccessComponent],
    imports: [
        SharedModule,
        PdfViewerModule,
        MenuModule,
        ButtonsModule
    ], exports: [
        ContentPreviewComponent,
        ContentAccessComponent
    ]
})
export class LinkAccessModule { }
